import { useEffect, useRef } from "react";

interface useWindowResizeProps {
  callback: () => void;
}

export const useWindowResize = ({ callback }: useWindowResizeProps) => {
  const refTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const resize = () => {
    if (refTimer.current) {
      clearTimeout(refTimer.current);
    }
    refTimer.current = setTimeout(() => {
      callback();
    }, 300);
  };

  useEffect(() => {
    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);
};

export { useGoogleAdsReport } from "./useGoogleAdsReport";
